import React from "react";
import "./MiniPipeline.scss";
import { Divider } from "antd";
import { IPipeline } from "@utils/Interfaces";

const MiniPipeline: React.FC<IPipeline> = ({ activePhase, phases }) => {
  const calculatePercentage = (
    startDateStr: string,
    endDateStr: string
  ): string => {
    const start = new Date(startDateStr).getTime();
    const end = new Date(endDateStr).getTime();
    const currentTime = new Date().getTime();

    if (currentTime >= end) {
      return "100";
    }

    if (currentTime <= start) {
      return "0";
    }

    const totalDuration = end - start;
    const elapsedDuration = currentTime - start;

    const percentage = (elapsedDuration / totalDuration) * 100;

    return percentage.toFixed(2);
  };

  return (
    <div className="MiniPipeline">
      <div className="MiniPipeline-group">
        {phases?.map((item: any, index: number) => {
          const status =
            activePhase - 1 > index
              ? "done"
              : activePhase - 1 == index
              ? "active"
              : "inactive";
          const percent = calculatePercentage(item.start_date, item.end_date);
          return (
            <div className={`Pipeline-item ${status}`} key={index}>
              <div className="item-info">
                <div className="Pipeline-title">{item.text}</div>
              </div>
              <ProgressItem percent={percent} status={status} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ProgressItem: React.FC<any> = ({ percent, status }) => {
  const progressStyle =
    status == "done"
      ? {}
      : status == "inactive"
      ? {
          backgroundColor: "#d9d9d9",
        }
      : {
          background: `linear-gradient(to right, #90d9d9 ${percent}%, #d9d9d9 ${percent}%)`,
        };
  return (
    <div className="item-progress" style={progressStyle}>
      <div className="progress" style={{ height: "1px", position: "relative" }}>
        {status == "inactive" && (
          <Divider
            className="divider"
            variant="dashed"
            style={{
              borderColor: "red",
              position: "absolute",
              zIndex: 2,
              width: percent + '%',
              minWidth: '0%'
            }}
            dashed
          />
        )}
        <Divider
          className="divider"
          variant="dashed"
          style={{ borderColor: "#fff", position: "absolute", zIndex: 1 }}
          dashed
        />
        <div
          className="progress-bar"
          style={{
            width: status == "active" ? percent + "%" : "0%",
            backgroundColor: "#09351B",
            zIndex: 2,
          }}
        ></div>
      </div>
      {(status == "active" || status == "inactive") &&
        percent < 100 &&
        percent != 0 && (
          <div
            className="progress-point"
            style={{ left: `calc(${percent}% - 3px)` }}
          ></div>
        )}
    </div>
  );
};

export default MiniPipeline;
